import React,{useEffect,useState} from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

import ListItem from '../components/ListItem';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import {allStates} from '../components/Helper';
import { BrowserRouter as Router,Routes, Route, Link,useParams } from 'react-router-dom';
import '../App.css';

const Home=()=>{

let { state } = useParams();

const [data, setData] = useState(null);
const [foundState, setFoundState] = useState([]);

const responsive = {
    // breakpoint from 0 up
    0 : {
      items:1
    },
    // breakpoint from 480 up
    560 : {
      items:2
    },
    // breakpoint from 768 up
    768 : {
        items:3
    }
  };

const dataFetch = async () => {

  if(typeof state === 'undefined'){
    state='';
  }
  fetch('https://api.hudhousingnetwork.com/waitingls?listtype=public_housing&state='+state)
        .then(response => response.json())
        .then((data) =>{ 
            setData(data);
          //console.log(data)
          }
        );

};

const stateFetch = async () => {

  if(typeof state === 'undefined'){
    return
  }
  fetch('https://api.hudhousingnetwork.com/get/'+state)
        .then(response => response.json())
        .then((data) =>{ 
          if(data.length>0)
          setFoundState(data[0].state);
          //console.log("R: "+data[0].state);
          }
        );

};


useEffect(()=>{
 console.log('Loaded!');  
 stateFetch();
 dataFetch();

},[])

const setClick=(val)=>{
  var url='/public-housing-waiting-lists/';
  url=url+val;
  window.location.href=url;
  //console.log("clicked "+val.toLowerCase())
}

/*allStates.map((postData) => {
  if(postData['state_code']=='AL'){
    console.log(postData['state'])
  }
})*/

  return (

<>
<Header />

<div className="home-banner">
      <div className="banner-text">
          <h1><span>HUD</span> HOUSING NETWORK</h1>
          <h2>Complete HUD Resources In One Conventient Location</h2>
          <ul>
            <li>
              <div><span className="bullet"></span><span className="txt">Section 8 <br />Rentals</span></div>
              <div><span className="bullet"></span><span className="txt">Housing<br />Vouchers</span></div>
            </li>
            <li>
              <div><span className="bullet"></span><span className="txt">Rental <br />Assistance</span></div>
              <div><span className="bullet"></span><span className="txt">Homebuying <br />Programs</span></div>
            </li>
          </ul>
          <div className="banner-search-container" data-dashlane-rid="0c1fa5d59d84a348" data-form-type="">
              <input style={{paddingLeft:40}} type="text" placeholder="Search By City" data-dashlane-rid="223d17f927478161" data-form-type="" />
              <button type="submit" className="stt" data-dashlane-rid="06275e4a05ebd3ae" data-dashlane-label="true" data-form-type="">Search</button>
          </div>

      </div>
</div>

<div className="section-two">
  <h2>Current Listings</h2>
  <div className="boxes-container">
    <div className="list-box2">
        <div className="thumb"><img src="/img/section8.png" alt="" /></div>
        <span className="date">14.04.2021</span>
        <h4>Single Family Home</h4>
        <ul>
            <li>Type: Section 8 Voucher Accepted </li>
            <li>Location: Trenton, NJ </li>
            <li>Bedrooms: 4 </li>
            <li>Bathrooms: 3 </li>
            <li>Sq. Feet: 2,284 sqft.</li>
        </ul>
        <a href="" className="list-link stt">Apply Now <i className="fa-solid fa-arrow-right"></i></a>
    </div>
    <div className="list-box2">
        <div className="thumb"><img src="/img/duplex.png" alt="" /></div>
        <span className="date">14.04.2021</span>
        <h4>Duplex / Townhouse</h4>
        <ul>
            <li>Type: Section 8 Voucher Accepted </li>
            <li>Location: Stockton, CA </li>
            <li>Bedrooms: 3 </li>
            <li>Bathrooms: 2 </li>
            <li>Sq. Feet: 1,775 sqft.</li>
        </ul>
        <a href="" className="list-link" >Apply Now <i className="fa-solid fa-arrow-right"></i></a>
    </div>
    <div className="list-box2">
        <div className="thumb"><img src="/img/low-income.png" alt="" /></div>
        <span className="date">14.04.2021</span>
        <h4>Low Income Apartment</h4>
        <ul>
            <li>Type: Section 8 Voucher Accepted </li>
            <li>Location: Clearwater, FL </li>
            <li>Bedrooms: 2, 3 and 4 available </li>
            <li>Bathrooms: 1 and 2 units </li>
            <li>Sq. Feet: 2,284 sqft.</li>
        </ul>
        <a href="" className="list-link">Apply Now <i className="fa-solid fa-arrow-right"></i></a>
    </div>

  </div>
</div>

<div className="section-three">
    <h1>Begin your search for Hud housing now</h1>
    <div className="search-container" data-dashlane-rid="0c1fa5d59d84a348" data-form-type="">
        <input style={{paddingLeft:40}} type="text" placeholder="Zip Code" data-dashlane-rid="223d17f927478161" data-form-type="" />
        <button type="submit" className="stt" data-dashlane-rid="06275e4a05ebd3ae" data-dashlane-label="true" data-form-type="">Get Started</button>
    </div>
</div>

<div className="section-four">
  <h2>Available Properties and Services</h2>
  <div className="boxes-container">
    <div className="list-box3">
        <div className="thumb"><img src="/img/section4-1.png" alt="" /></div>
        <h4>Section 8 Housing</h4>
        <p>Section 8 housing is a federal housing assistance program that helps low-income families pay for rental housing. Eligible families receive a voucher from the government to help cover a portion of their rent, with the remaining amount paid by the tenant.</p>
        <a href="" className="property-link active">Apply Now <i className="fa-solid fa-arrow-right"></i></a>
    </div>
    <div className="list-box3">
        <div className="thumb"><img src="/img/section4-2.png" alt="" /></div>
        <h4>Public Housing</h4>
        <p>Public housing is government owned and operated rental housing for low-income families, senior citizens, and people with disabilities. Residents typically pay rent based on their income, and the units are managed by local housing authorities.</p>
        <a href="" className="property-link" >Apply Now <i className="fa-solid fa-arrow-right"></i></a>
    </div>
    <div className="list-box3">
        <div className="thumb"><img src="/img/section4-3.png" alt="" /></div>        
        <h4>Emergency Rental Assistance</h4>        
        <p>Emergency rental assistance programs provide financial assistance to low-income renters facing eviction or homelessness. These programs can cover expenses such as rent, security deposits, and utility bills. The programs are usually funded by government agencies, charitable organizations, or a combination of both. </p>
        <a href="" className="property-link">Apply Now <i className="fa-solid fa-arrow-right"></i></a>
    </div>
  </div>
  <div style={{marginTop:100,marginBottom:100}}></div>
  <div className="boxes-container">
    <div className="list-box3">
        <div className="thumb"><img src="/img/section4-4.png" alt="" /></div>
        <h4>Housing Voucher Waiting Lists</h4>
        <p>Housing voucher waiting lists are administered by local public housing authorities and are typically managed using a combination of eligibilty requirements and first-come, first-serve basis. Vouchers provide rental assistance for eligible individuals and families.</p>
        <a href="" className="property-link active">Apply Now <i className="fa-solid fa-arrow-right"></i></a>
    </div>
    <div className="list-box3">
        <div className="thumb"><img src="/img/section4-5.png" alt="" /></div>
        <h4>Assistance Programs</h4>
        <p>There are many assistance programs available for housing, utility bills, transportation, homelessness and more.</p>
        <a href="" className="property-link" >Apply Now <i className="fa-solid fa-arrow-right"></i></a>
    </div>
    <div className="list-box3">
        <div className="thumb"><img src="/img/section4-6.png" alt="" /></div>        
        <h4>In Depth Guides</h4>        
        <p>Our in-depth guides offer step by step instructions for securing assistance for many federal, state, and local governments as well as various non-profits and other charitable organizations.</p>
        <a href="" className="property-link">Apply Now <i className="fa-solid fa-arrow-right"></i></a>
    </div>

  </div>

  <div className="section-four-b"> 
      <h1>What Our Users Are Saying</h1>
      <p className="tag-line">Don’t take our word for it. Trust our customers</p>
      <OwlCarousel className='owl-theme' loop margin={3} responsive={responsive} nav>
          <div className="item testi-box">
              <img src="/img/pic1.png" alt="" />
              <h4>Robert Fox</h4>
              <span>Family Man</span>
              <p>My family was in desperate need of housing. Specifically, we needed a 3br 2ba house in Des Moines IA. Luckily we found HUD Housing Network and they found our house, got us on the waiting list in Des Moines, and i was able to secure housing with my Section 8 Voucher.</p>
          </div>
          <div className="item testi-box">
              <img src="/img/pic2.png" alt="" />
              <h4>Esther Howard</h4>
              <span>Public Housing Recipient</span>
              <p>I had been searching for clean, affordable, public housing for months. I had been unable to secure new housing after being forced to move until i found HUD Housing Network. Thankfully i did and they were able to get me a 1br apartment.<br />&nbsp;<br /></p>
          </div>
          <div className="item testi-box">
              <img src="/img/pic3.png" alt="" />
              <h4>Leslie Alexander</h4>
              <span>Delivery Manager</span>
              <p>Finding housing for a family of 4 with a Housing Voucher is not always easy. I found HUD Housing Network and they were able to connect me with housing providers that accepted my voucher. Im so grateful for their help.<br />&nbsp;<br /></p>
          </div>
          <div className="item testi-box">
              <img src="/img/pic1.png" alt="" />
              <h4>Robert Fox</h4>
              <span>Family Man</span>
              <p>My family was in desperate need of housing. Specifically, we needed a 3br 2ba house in Des Moines IA. Luckily we found HUD Housing Network and they found our house, got us on the waiting list in Des Moines, and i was able to secure housing with my Section 8 Voucher.</p>
          </div>
          <div className="item testi-box">
              <img src="/img/pic2.png" alt="" />
              <h4>Esther Howard</h4>
              <span>Public Housing Recipient</span>
              <p>I had been searching for clean, affordable, public housing for months. I had been unable to secure new housing after being forced to move until i found HUD Housing Network. Thankfully i did and they were able to get me a 1br apartment.<br />&nbsp;<br /></p>
          </div>
          <div className="item testi-box">
              <img src="/img/pic3.png" alt="" />
              <h4>Leslie Alexander</h4>
              <span>Delivery Manager</span>
              <p>Finding housing for a family of 4 with a Housing Voucher is not always easy. I found HUD Housing Network and they were able to connect me with housing providers that accepted my voucher. Im so grateful for their help.<br />&nbsp;<br /></p>
          </div>
          <div className="item testi-box">
              <img src="/img/pic1.png" alt="" />
              <h4>Robert Fox</h4>
              <span>Family Man</span>
              <p>My family was in desperate need of housing. Specifically, we needed a 3br 2ba house in Des Moines IA. Luckily we found HUD Housing Network and they found our house, got us on the waiting list in Des Moines, and i was able to secure housing with my Section 8 Voucher.</p>
          </div>
          <div className="item testi-box">
              <img src="/img/pic2.png" alt="" />
              <h4>Esther Howard</h4>
              <span>Public Housing Recipient</span>
              <p>I had been searching for clean, affordable, public housing for months. I had been unable to secure new housing after being forced to move until i found HUD Housing Network. Thankfully i did and they were able to get me a 1br apartment.<br />&nbsp;<br /></p>
          </div>
          <div className="item testi-box">
              <img src="/img/pic3.png" alt="" />
              <h4>Leslie Alexander</h4>
              <span>Delivery Manager</span>
              <p>Finding housing for a family of 4 with a Housing Voucher is not always easy. I found HUD Housing Network and they were able to connect me with housing providers that accepted my voucher. Im so grateful for their help.<br />&nbsp;<br /></p>
          </div>
          
      </OwlCarousel>
  </div>


</div>


<div className="section-five">
  <div className="home-subscription">        
        <div className="container">            
            <div className="subscription-content">
                <h1>WAITING LISTS ARE OPEN NEAR YOU SIGNUP FOR ALERTS</h1>
                <p>Apply Now - Get Your Application Guide - Get regular updates for open waiting lists</p>
                <button className="stt">Get Started</button>
            </div>
        </div>
        <div className="hand"><img src="/img/hand-with-leaf.png" alt="" /></div>
    </div>
</div>


<footer>
    <div className="container">
        <div className="row">
            <div className="footer-left">© 2023 Copyright HUD Housing Network</div>
            <div className="footer-right">
                <div className="f-nav">
                    <ul>
                        <li><a href="https://hudhousingnetwork.com/privacy">Privacy Policy</a></li>
                        <li>|</li>
                        <li><a href="https://hudhousingnetwork.com/terms">Terms &amp; Conditions </a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</footer>












{/*}
  <div className="content_wrapper">
    <div className="main-content">
      <h2 className="top-heading">Public Housing Waiting Lists {foundState!="" ? 'for '+foundState : ''}</h2>
      
      <select className="statesDD" onChange={(e)=>setClick(e.target.value)} >
      {
          allStates.map((postData,index) => {            
            var selected = postData['state_code'].toLowerCase()==state ? 'selected' : '';
            return (<option key={index} selected={selected} value={postData['state_code'].toLowerCase()}>{postData['state']}</option>)
          
        })
      }        
      </select><br />
      
      {data!=null && (
      
          data.map((item,index) => (
            <ListItem key={index} item={item} />
          ))

      )
    }

    {data!=null && data.length==0 && (
    <span className="sorry">Sorry we are unable to find any matching records!</span>)
    }          
    </div>
  <Sidebar />
  </div>
  <div className="content_wrapper">
    <div className="side-box">
      <img src="/img/apt1.png" />
      <div className="side-box-content">
        <h3>Spring View Apartments</h3>
        <p>Read our getting started guide</p>
        <div className="side-box-flex">
          <h4>Section 8 Apartment</h4>
          <a className="applyLink" href="/">Apply</a>  
        </div>  
      </div>
    </div>
    <div className="side-box">
      <img src="/img/apt2.png" alt="" />
      <div className="side-box-content">
        <h3>Spring View Apartments</h3>
        <p>Read our getting started guide</p>
        <div className="side-box-flex">
          <h4>Section 8 Apartment</h4>
          <a className="applyLink" href="/">Apply</a>  
        </div>  
      </div>
    </div>
    <div className="side-box">
      <img src="/img/apt2.png" />
      <div className="side-box-content">
        <h3>Spring View Apartments</h3>
        <p>Read our getting started guide</p>
        <div className="side-box-flex">
          <h4>Section 8 Apartment</h4>
          <a className="applyLink" href="/">Apply</a>  
        </div>  
      </div>
    </div>
  </div>
  <div className="content_wrapper">
    <div className="bottom-box">
      <div className="bottom-box-flex">
        <div className="bottom-box-image"><img src="/img/Housing-authority.png" /></div>
        <div className="bottom-box-content">
          <h2>Housing-authority</h2>
          <p>1243 West Sycamore Lafayette GA, 29010</p>
        </div>
      </div>
      <div className="bottom-box-flex2">
        <a href="" className="contact-us-link">Contact Us</a>
        <div className="bottom-box-icon">
          <img src="/img/Group238491.png" />
          <img src="/img/Group238493.png" />
        </div>
      </div>
    </div>  
  </div>

{*/}






</>
  );
}

export default Home;
